import { Controller } from "@hotwired/stimulus"

// The emoji popover under a message: closes and clears after a boost.
export default class extends Controller {
  close(event) {
    if (event.detail?.success === false) return
    this.element.removeAttribute("open")
    this.element.querySelectorAll("input[type=text]").forEach((i) => (i.value = ""))
  }
}
